import {
  GET_All_USERS,
  ADD_REGISTERED_USER,
  REMOVE_USER,
  REMOVE_ADDED_USER,
  GET_USER_BY_ID,
  CURRENT_USER,
  USER_TOTAL_PAGE,
  ALL_USERS_CURRENT_PAGE,
  SET_SEARCH_USERS_PARAMS,
  GET_ACCESS_LIST,
  ACCESS_LIST_CURRENT_PAGE,
  ACCESS_LIST_TOTAL_PAGES,
  REMOVE_SINGLE_ACCESS,
  GET_ACCESS_LIST_MANAGEMENT,
  AL_MANAGEMENT_CURRENT_PAGE,
  AL_MANAGEMENT_TOTAL_PAGES,
  REMOVE_SINGLE_AL_MANAGEMENT,
  GET_ADMIN_LOGS,
  ADMIN_LOGS_CURRENT_PAGE,
  ADMIN_LOGS_TOTAL_COUNT,
  GET_SINGLE_ADMIN_LOG,
  SET_ADMIN_LOG_DB,
} from "../../@jumbo/constants/ActionTypes";

const INIT_STATE = {
  userByID: null,
  allUsers: [],
  allUsersTotalPages: 0,
  registeredUsers: [],
  userById: null,
  currentUser: null,
  allUsersCurrentPage: 1,
  userSearchParams: "",
  accessList: [],
  accessListCurrentPage: 1,
  accessListTotalPages: 0,
  accessManagementList: [],
  amListCurrentPage: 1,
  amListTotalPages: 0,
  adminLogs: [],
  adminLogsCurrentPage: 1,
  adminLogsTotalPages: 0,
  adminLog: null,
  adminLogDB: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_All_USERS: {
      return {
        ...state,
        allUsers: action.payload,
      };
    }
    case ADD_REGISTERED_USER: {
      return {
        ...state,
        registeredUsers: [...state.registeredUsers, action.payload],
      };
    }
    case GET_USER_BY_ID: {
      return {
        ...state,
        userByID: action.payload,
      };
    }
    case USER_TOTAL_PAGE: {
      return {
        ...state,
        allUsersTotalPages: action.payload,
      };
    }
    case CURRENT_USER: {
      return {
        ...state,
        currentUser: action.payload,
      };
    }
    case ALL_USERS_CURRENT_PAGE: {
      return {
        ...state,
        allUsersCurrentPage: action.payload,
      };
    }
    case SET_SEARCH_USERS_PARAMS: {
      return {
        ...state,
        userSearchParams: action.payload,
      };
    }
    case REMOVE_USER: {
      const removedUser = action.payload;
      const allUsersCopy = [...state.allUsers];
      if (allUsersCopy.lenght !== 0) {
        allUsersCopy.forEach((user, index) => {
          if (user._id === removedUser) {
            allUsersCopy.splice(index, 1);
          }
        });
      }
      return {
        ...state,
        allUsers: allUsersCopy,
      };
    }
    case REMOVE_SINGLE_ACCESS: {
      const toBeRemovedId = action.payload;
      const accessListCopy = [...state.accessList];
      if (accessListCopy.lenght !== 0) {
        accessListCopy.forEach((user, index) => {
          if (user._id === toBeRemovedId) {
            accessListCopy.splice(index, 1);
          }
        });
      }
      return {
        ...state,
        accessList: accessListCopy,
      };
    }
    case REMOVE_ADDED_USER: {
      const removedAddedUser = action.payload;
      const registerdUsersCopy = state.registeredUsers;
      if (registerdUsersCopy.lenght !== 0) {
        registerdUsersCopy.forEach((user, index) => {
          if (user._id === removedAddedUser) {
            registerdUsersCopy.splice(index, 1);
          }
        });
      }
      return {
        ...state,
        registeredUsers: registerdUsersCopy,
      };
    }
    case GET_ACCESS_LIST: {
      return {
        ...state,
        accessList: action.payload,
      };
    }
    case ACCESS_LIST_CURRENT_PAGE: {
      return {
        ...state,
        accessListCurrentPage: action.payload,
      };
    }
    case ACCESS_LIST_TOTAL_PAGES: {
      return {
        ...state,
        accessListTotalPages: action.payload,
      };
    }
    case GET_ACCESS_LIST_MANAGEMENT: {
      return {
        ...state,
        accessManagementList: action.payload,
      };
    }
    case AL_MANAGEMENT_CURRENT_PAGE: {
      return {
        ...state,
        amListCurrentPage: action.payload,
      };
    }
    case AL_MANAGEMENT_TOTAL_PAGES: {
      return {
        ...state,
        amListTotalPages: action.payload,
      };
    }
    case REMOVE_SINGLE_AL_MANAGEMENT: {
      const toBeRemovedId = action.payload;
      const accessListCopy = [...state.accessManagementList];
      if (accessListCopy.lenght !== 0) {
        accessListCopy.forEach((user, index) => {
          if (user._id === toBeRemovedId) {
            accessListCopy.splice(index, 1);
          }
        });
      }
      return {
        ...state,
        accessManagementList: accessListCopy,
      };
    }
    case GET_ADMIN_LOGS: {
      return {
        ...state,
        adminLogs: action.payload,
      };
    }
    case ADMIN_LOGS_CURRENT_PAGE: {
      return {
        ...state,
        adminLogsCurrentPage: action.payload,
      };
    }
    case ADMIN_LOGS_TOTAL_COUNT: {
      return {
        ...state,
        adminLogsTotalPages: action.payload,
      };
    }
    case GET_SINGLE_ADMIN_LOG: {
      return {
        ...state,
        adminLog: action.payload,
      };
    }
    case SET_ADMIN_LOG_DB: {
      return {
        ...state,
        adminLogDB: action.payload,
      };
    } 
    default:
      return state;
  }
};
